export default "__VITE_ASSET__ho4qExhf__"